import request from '../utils/request'
import { getToken } from '../utils/auth'

export function fetchArtistList(filter) {
  return request({
    url: '/api/artists',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function fetchArtistLangList(filter) {
  return request({
    url: '/api/artist_langs',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function fetchArtist(id, filter) {
  return request({
    url: '/api/artists/' + id,
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function createArtist(data) {
  return request({
    url: '/api/artists',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function updateArtist(id, data) {
  return request({
    url: '/api/artists/' + id ,
    method: 'patch',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function createArtistLang(data) {
  return request({
    url: '/api/artist_langs',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function updateArtistLang(id, data) {
  return request({
    url: '/api/artist_langs/' + id ,
    method: 'patch',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function deleteArtist(id) {
  return request({
    url: '/api/artists/' + id,
    method: 'delete',
    params: {
      'access_token': getToken()
    }
  })
}

export function deleteArtistLang(id) {
  return request({
    url: '/api/artist_langs/' + id,
    method: 'delete',
    params: {
      'access_token': getToken()
    }
  })
}
